import { z } from "zod";

export const DTOAssetRenderConfiguration = z.object({
  prefix: z.string().optional(),
  suffix: z.string().optional(),
  scale: z.enum(["x1", "x2", "x3", "x4"]),
  format: z.enum(["png", "pdf", "svg"]),
});

export const DTORenderedAssetFile = z.object({
  assetId: z.string(),
  fileName: z.string(),
  sourceUrl: z.string(),
  settings: DTOAssetRenderConfiguration,
  originalName: z.string(),
});

export const DTODownloadAssetsRequest = z.object({
  persistentIds: z.array(z.string().uuid()).optional(),
  settings: DTOAssetRenderConfiguration.array(),
});

export const DTODownloadAssetsResponse = z.object({
  items: DTORenderedAssetFile.array(),
});

export type DTOAssetRenderConfiguration = z.infer<typeof DTOAssetRenderConfiguration>;
export type DTORenderedAssetFile = z.infer<typeof DTORenderedAssetFile>;
export type DTODownloadAssetsRequest = z.infer<typeof DTODownloadAssetsRequest>;
export type DTODownloadAssetsResponse = z.infer<typeof DTODownloadAssetsResponse>;
